import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ConfirmComponent } from 'src/app/dialog/confirm/confirm.component';
import {
    TransactionFeeModelInterface,
    TransactionFeeModelResponse,
} from 'src/app/interface/transaction-fee-model.interface';
import {
    UserModelInterface,
    UserModelResponse,
} from 'src/app/interface/user-model.interface';
import { OpenIdProfileBase } from 'src/app/mixin/presets';
import { OpenIdService } from 'src/app/service/open-id.service';

abstract class UpdateableList<InterfaceType> {
    private _data: InterfaceType[] = [];
    abstract order(a: InterfaceType, b: InterfaceType): number;
    abstract equal(a: InterfaceType, b: InterfaceType): boolean;

    public get data() {
        return this._data;
    }

    public set data(e: InterfaceType[]) {
        this._data = e;
        this.sort();
    }

    public push(e: InterfaceType) {
        this.data.push(e);
        this.sort();
    }

    public remove(e: InterfaceType) {
        let updated: InterfaceType[] = [];
        for (let item of this.data) {
            if (!this.equal(e, item)) {
                updated.push(item);
            }
        }

        this.data = updated;
    }

    public sort() {
        this._data = this._data.sort((a: InterfaceType, b: InterfaceType) =>
            this.order(a, b)
        );
    }

    public update(e: InterfaceType) {
        this.remove(e);
        this.push(e);
    }
}

class TransactionFeeModelList extends UpdateableList<TransactionFeeModelInterface> {
    public order(
        a: TransactionFeeModelInterface,
        b: TransactionFeeModelInterface
    ) {
        if (a.id == b.id) return 0;
        return a.user!.email > b.user!.email ? 1 : -1;
    }

    public equal(
        a: TransactionFeeModelInterface,
        b: TransactionFeeModelInterface
    ) {
        return a.id == b.id;
    }
}

@Component({
    selector: 'app-view-fees',
    templateUrl: './fees.component.html',
    styleUrls: ['./fees.component.css'],
})
export class FeesComponent extends OpenIdProfileBase implements OnInit {
    public formGroup = new FormGroup({
        open_id: new FormControl('', [Validators.required]),
        rate: new FormControl(0, [Validators.required]),
    });
    public columnHeadings: string[] = [
        'control',
        'id',
        'user',
        'rate',
        'created_at',
    ];

    //public transactionFeeModels: TransactionFeeModelInterface[] = [];
    public transactionFeeModels = new TransactionFeeModelList();

    public modTransactionFeeModel?: TransactionFeeModelInterface;
    public activeUser?: UserModelInterface;

    public users: UserModelInterface[] = [];

    @ViewChild('feeTable', { static: true }) table?: MatTable<any>;

    constructor(
        private dialog: MatDialog,
        private httpClient: HttpClient,
        openIdService: OpenIdService
    ) {
        super(openIdService);
    }

    ngOnInit(): void {
        //this.modifyFee();
        this.$openIdReady.subscribe(() => {
            this.httpClient
                .get<UserModelResponse>('users')
                .subscribe((response: UserModelResponse) => {
                    this.users = response.results;
                });
            this.getTransactionFees();
        });
    }

    public confirmDelete(transactionFeeModel: TransactionFeeModelInterface) {
        let dialog = this.dialog.open(ConfirmComponent, {
            data: {
                label: 'Fee Delete Request',
                message: `Delete transaction fee for ${
                    transactionFeeModel.user!.email
                }?`,
            },
        });

        dialog.afterClosed().subscribe((data) => {
            if (!data.data) return;
            this.httpClient
                .delete(`transaction_fees/${transactionFeeModel.id}/`)
                .subscribe(() => {
                    this.transactionFeeModels.remove(transactionFeeModel);
                });
        });
    }

    public modifyFee(transactionFeeModel?: TransactionFeeModelInterface) {
        if (!transactionFeeModel) {
            transactionFeeModel = {
                id: 0,
                open_id: '',
                rate: 0,
            } as TransactionFeeModelInterface;
        }
        this.modTransactionFeeModel = transactionFeeModel;
        this.formGroup.setValue({
            open_id: transactionFeeModel.open_id,
            rate: transactionFeeModel.rate,
        });
    }

    private getTransactionFees() {
        this.httpClient
            .get<TransactionFeeModelResponse>('transaction_fees')
            .subscribe((response: TransactionFeeModelResponse) => {
                this.transactionFeeModels.data = response.results;
            });
    }

    public saveFee() {
        let payload = {
            open_id: this.formGroup.get('open_id')!.value,
            rate: this.formGroup.get('rate')!.value,
        };

        if (this.modTransactionFeeModel!.id == 0) {
            this.httpClient
                .post<TransactionFeeModelInterface>(
                    'transaction_fees/',
                    payload
                )
                .subscribe((response: TransactionFeeModelInterface) => {
                    this.transactionFeeModels.push(response);
                    this.table?.renderRows();
                    this.modTransactionFeeModel = undefined;
                });
        } else {
            let url = `transaction_fees/${this.modTransactionFeeModel!.id}/`;
            this.httpClient
                .put<TransactionFeeModelInterface>(url, payload)
                .subscribe((response: TransactionFeeModelInterface) => {
                    this.transactionFeeModels.update(response);
                    this.modTransactionFeeModel = undefined;
                });
        }
    }

    public updateSelectedUser(user: UserModelInterface) {
        let open_id = '';
        if (user) {
            open_id = user.username;
        }

        this.formGroup.get('open_id')!.setValue(open_id);
    }
}

/*

abstract class Sortable<InterfaceType> {
    abstract compare(a: InterfaceType, b: InterfaceType): number;
    abstract equal(a: InterfaceType, b: InterfaceType): boolean;
}

class TransactionFeeSortable extends Sortable<TransactionFeeModelInterface> {
    public compare(
        a: TransactionFeeModelInterface,
        b: TransactionFeeModelInterface
    ) {
        if (a.id == b.id) return 0;
        return a.user!.email > b.user!.email ? 1 : -1;
    }

    public equal(
        a: TransactionFeeModelInterface,
        b: TransactionFeeModelInterface
    ) {
        return true;
    }
}

abstract class UpdateableList<InterfaceType> {
    public data: InterfaceType[] = [];

    abstract order(a: InterfaceType, b: InterfaceType): number;
    abstract equal(a: InterfaceType, b: InterfaceType): boolean;

    public push(e: InterfaceType) {
        this.data.push(e);
        this.sort();
    }

    public remove(e: InterfaceType) {
        let updated: InterfaceType[] = [];
        for (let item of this.data) {
            if (!this.equal(e, item)) {
                updated.push(item);
            }
        }

        this.data = updated;
    }

    public sort() {
        this.data = this.data.sort((a: InterfaceType, b: InterfaceType) =>
            this.order(a, b)
        );
    }

    public update(e: InterfaceType) {
        this.remove(e);
        this.push(e);
    }
}

class TransactionFeeModelList extends UpdateableList<TransactionFeeModelInterface> {
    public order(
        a: TransactionFeeModelInterface,
        b: TransactionFeeModelInterface
    ) {
        if (a.id == b.id) return 0;
        return a.user!.email > b.user!.email ? 1 : -1;
    }

    public equal(
        a: TransactionFeeModelInterface,
        b: TransactionFeeModelInterface
    ) {
        return a.id == b.id;
    }
}
*/
